import { Image } from '../models/image';
import { People } from '../models/people.model';
import { Person } from '../models/person';
import { PersonStatus } from '../models/personStatus';
import { IPersonTag } from '../models/personTag.model';
import { Tag } from '../models/tag';

export class MergeProfileModel {
  public id: string;
  public fullName: string;
  public email: string;
  public updatedOn: Date;
  public status: string;
  public tags: Tag[] | IPersonTag[] = [];
  public image: Image;
  constructor(data: People | Person) {
    ((this.id = data.id), (this.email = data.email));
    this.fullName = data.fullName;
    this.updatedOn = data.updatedOn;
    this.status = data.status;
    this.tags = data.tags;
    this.image = data.image;
  }

  isArchived() {
    return this.status == PersonStatus.Archived;
  }

  isActive() {
    return this.status == PersonStatus.Active;
  }

  isPotential() {
    return this.status == PersonStatus.Potential;
  }
}
